<template>
    <div class="top_con">
       <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="88px">
           <el-row :gutter="8" >
                <el-col :span="6">
                    <el-form-item label="合同名称"> 
                        <el-input v-model="formInline.contractname"  placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备编号">
                        <el-input v-model="formInline.equipmentnum" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备归属人">
                        <el-input v-model="formInline.belonger" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="产权编号">
                        <el-input v-model="formInline.propertynum" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="6">
                    <el-form-item label="收益时间"> 
                        <el-select v-model="formInline.typec" placeholder="请选择" style="margin-right:20px;" :disabled="tit_type==1?true:false">
                            <el-option label="今天" value="1"></el-option>
                            <el-option label="本月" value="2"></el-option>
                            <el-option label="本季度" value="3"></el-option>
                            <el-option label="今年" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <div style="float:right;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearS">重置</el-button>
                    </el-form-item>
                </div>
            </el-row>
        </el-form>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" max-height="600px">
            <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
            <el-table-column  prop="newId"  label="ID"></el-table-column>
            <el-table-column  label="合同编号">
                 <template slot-scope="scope">
                      <el-link type="primary"  @click="open_sy(scope.row.id)">{{scope.row.contractnum}}</el-link>
                 </template>
            </el-table-column>
            <el-table-column prop="contractname"  label="合同名称"></el-table-column>
            <el-table-column prop="address"  label="合同地址" show-overflow-tooltip></el-table-column>
            <el-table-column prop="shouyi"  label="合同收益" ></el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
    </div>
</template>
<script>
import {SyIndex,openXq,} from '@/utils/api'
export default {
    data(){
        return{
            houseLis:[],
            formInline: {
                contractname:'',
                equipmentnum:'',
                belonger:'',
                propertynum:'',
                typec:'',
            },
            roleid:'',
            dialogFormVisible:false,
            chuKu:false,
            zp_tit:"添加库存",
            tit_type:0,
            form:{
                bianhao:'',
                wid:'',
                prodname:'',
                rkjine:'',
                price:'',
                num:'',
                zcost:'',
                dcost:'',
                sprice:'',
                profitratio:'',
                img:[]
            },
            formLabelWidth: '120px',
            value:9,
            total:10,
            pageNum:1,
            multipleSelection:[],
            tableData: [],
            fileList: [],
            ckid:'',
            cknum:'',
            user:{}
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                formInline:this.formInline
            }
            SyIndex(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        handleRemove(file, fileList) {
            let idx=this.fileList.findIndex(item => {
                if (item.name == file.name) {
                    return true
                }
            })
            this.fileList.splice(idx, 1)
        },
        onSubmit(){
            let param ={
                numPerPage:this.value,
                pageNum:1,
                formInline:this.formInline
            }
            SyIndex(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list;
            });
        },
        clearS(){
            this.formInline={}
            SyIndex().then(res=>{
                this.total=res.total;
                this.tableData=res.list;
            });
        },
        look(idx,id){
            this.dialogFormVisible=true
            if(idx==0){
                this.zp_tit="添加库存";
                this.tit_type=0;
                 this.form={}
            }else if(idx==1){
                this.zp_tit="查看详情";
                this.tit_type=1;
                openXq({id:id}).then(res=>{
                   this.form=res;
                })
            }else if(idx==2){
                this.zp_tit="编辑";
                this.tit_type=2;
                openXq({id:id}).then(res=>{
                   this.form=res;
                   this.fileList=this.form.img
                })
            }
            
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        open_sy(id){
            this.$router.push({
                path:'/CashFlows',
                query:{
                    id:id,
                    info:this.formInline
                }
            })
       }
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
         let param ={
            numPerPage:this.value,
            pageNum:this.pageNum
        }
        SyIndex(param).then(res=>{
            this.total=res.total;
            this.tableData=res.list;
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
      .el-image{
        margin-right:30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/QueryPricing.vue